<div class="ack-overlay">
  <div class="ack-overlay-header">
    <div>
      <h2 class="ack-overlay-title">CUSTOMER ORDER ACKNOWLEDGMENT</h2>
      <p class="ack-customer" *ngIf="customerName">{{ customerName }}</p>
    </div>
    <div class="ack-header-right">
      <div class="ack-invoice" *ngIf="invoiceNumber">No. {{ invoiceNumber }}</div>
      <button
        mat-button
        type="button"
        (click)="dialogRef.close()"
        aria-label="Close acknowledgment"
      >
        CLOSE
      </button>
    </div>
  </div>

  <div class="ack-body">
    <div class="ack-main">
      <p class="ack-language">{{ language }}</p>
      <p class="ack-note" *ngIf="hasCompletionDate">
        Requested completion date is a customer request and is not an unconditional guarantee.
      </p>

      <div class="signature-pad-wrap" *ngIf="!staffOverride">
        <canvas
          #signaturePad
          class="signature-pad"
          (mousedown)="startDraw($event)"
          (mousemove)="moveDraw($event)"
          (mouseup)="endDraw()"
          (mouseleave)="endDraw()"
          (touchstart)="startDraw($event)"
          (touchmove)="moveDraw($event)"
          (touchend)="endDraw()"
        ></canvas>
        <div class="signature-line" aria-hidden="true"></div>
        <div class="signature-hint">Your Signature</div>
      </div>

      <div class="ack-override" *ngIf="staffOverride">
        <p class="ack-override-warning">
          Employees must not sign the customer signature field. Record the
          authorization method and reason instead.
        </p>
        <mat-form-field appearance="fill">
          <mat-label>AUTHORIZATION METHOD</mat-label>
          <mat-select [formControl]="staffMethod">
            <mat-option *ngFor="let method of staffMethods" [value]="method">
              {{ method }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>REASON</mat-label>
          <input matInput [formControl]="staffReason" autocomplete="off">
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>NOTE {{ staffMethod.value === 'Other' ? '(REQUIRED)' : '' }}</mat-label>
          <textarea matInput rows="3" [formControl]="staffNote"></textarea>
        </mat-form-field>
      </div>
    </div>

    <aside class="ack-charges">
      <div class="ack-charge-row" *ngFor="let row of charges">
        <div class="ack-charge-label">{{ row.label }}</div>
        <div class="ack-charge-value">
          <span>$</span>
          <span>{{ formatMoney(row.value) }}</span>
        </div>
      </div>
    </aside>
  </div>

  <div class="ack-actions">
    <button mat-button type="button" (click)="clearSignature()" *ngIf="!staffOverride">
      CLEAR
    </button>
    <button mat-button type="button" (click)="toggleStaffOverride()">
      {{ staffOverride ? 'CUSTOMER SIGNATURE' : 'PROCEED WITHOUT CUSTOMER SIGNATURE' }}
    </button>
    <span class="ack-actions-spacer"></span>
    <button
      mat-raised-button
      color="primary"
      type="button"
      [disabled]="staffOverride ? !canConfirmOverride : !hasSignature"
      (click)="confirm()"
    >
      {{ staffOverride ? 'RECORD AUTHORIZATION' : 'SIGN &amp; ACKNOWLEDGE' }}
    </button>
  </div>
</div>
